import { useEffect } from 'react'
import { View } from 'react-native'
import Animated, {
  Easing,
  cancelAnimation,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated'
import { colors } from '@ui/colors'
import { LoaderOuter } from './assets/loader'
import { AnimationComponentProps as Props } from './phaseAnimation'

const REFERENCE_SIZE = 24
const DURATION = 1000

export default function LoaderSingle({
  size = REFERENCE_SIZE,
  color = colors.white,
  isActive = true,
}: Props) {
  const outerRotation = useSharedValue(0)

  useEffect(() => {
    if (!isActive) {
      cancelAnimation(outerRotation)
      return
    }

    outerRotation.set(0)

    outerRotation.set(
      withRepeat(
        withTiming(360, { duration: DURATION, easing: Easing.linear }),
        -1,
        false
      )
    )
  }, [isActive, outerRotation])

  const outerStyle = useAnimatedStyle(() => ({
    transform: [{ rotate: `${outerRotation.value}deg` }],
  }))

  return (
    <View
      style={{ width: size, height: size }}
      className="items-center justify-center"
    >
      {/* Absolute wrappers need explicit dimensions on native: without
          them the view collapses to 0x0 and the SVG at 100% renders nothing. */}
      <Animated.View
        className="absolute"
        style={[{ width: size, height: size }, outerStyle]}
      >
        <LoaderOuter size="100%" color={color} />
      </Animated.View>
    </View>
  )
}
